/*
 * Knowledge base content loader. Articles are markdown files with frontmatter
 * under ./articles/<category-slug>/<article-slug>.md, bundled at build time —
 * no backend involved. Content was migrated from https://kb.ashoreapp.com/.
 */

/*
 * Minimal frontmatter parser — our migration script only emits flat
 * `key: "quoted string"` pairs, so a full YAML parser isn't needed.
 */
function parseFrontmatter(raw) {
  const match = /^---\n([\s\S]*?)\n---\n?/.exec(raw);
  if (!match) {
    return { meta: {}, body: raw };
  }
  const meta = {};
  match[1].split("\n").forEach((line) => {
    const idx = line.indexOf(":");
    if (idx === -1) return;
    const key = line.slice(0, idx).trim();
    let value = line.slice(idx + 1).trim();
    if (value.startsWith('"') && value.endsWith('"')) {
      value = value.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, "\\");
    }
    meta[key] = value;
  });
  return { meta, body: raw.slice(match[0].length) };
}

function stripMarkdown(md) {
  return md
    .replace(/<[^>]+>/g, " ")
    .replace(/!\[[^\]]*\]\([^)]*\)/g, " ")
    .replace(/\[([^\]]*)\]\([^)]*\)/g, "$1")
    .replace(/[#>*_`~-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

const context = require.context("./articles", true, /\.md$/);

const articles = context
  .keys()
  .map((key) => {
    const { meta, body } = parseFrontmatter(context(key));
    const plainText = stripMarkdown(body);
    return {
      ...meta,
      body,
      excerpt: meta.excerpt || plainText.slice(0, 180) + (plainText.length > 180 ? "…" : ""),
      searchText: (meta.title + " " + plainText).toLowerCase(),
    };
  })
  .sort((a, b) => a.title.localeCompare(b.title));

const categories = [];
articles.forEach((a) => {
  let cat = categories.find((c) => c.slug === a.categorySlug);
  if (!cat) {
    cat = { slug: a.categorySlug, name: a.category, count: 0 };
    categories.push(cat);
  }
  cat.count++;
});
categories.sort((a, b) => a.name.localeCompare(b.name));

export function getAllArticles() {
  return articles;
}

export function getCategories() {
  return categories;
}

export function getArticleBySlug(slug) {
  return articles.find((a) => a.slug === slug) || null;
}

export function getRelatedArticles(article, limit = 5) {
  return articles
    .filter((a) => a.categorySlug === article.categorySlug && a.slug !== article.slug)
    .slice(0, limit);
}

export function searchArticles(query, categorySlug) {
  const q = (query || "").trim().toLowerCase();
  return articles.filter((a) => {
    if (categorySlug && a.categorySlug !== categorySlug) return false;
    if (!q) return true;
    return q.split(/\s+/).every((term) => a.searchText.includes(term));
  });
}
